import React, { useCallback } from 'react'
import contactIcon from '../../../../assets/contact-icon.png'
import styles from './Contact.module.css'
import { useTranslation } from "react-i18next";

const Contact = (props) => {
    const [t] = useTranslation('common')
    const { fullName, email, mainPhone, _id } = props.contact
    const appAccess = props.appAccess
    let checkEmailIfExample = email;

    if (checkEmailIfExample?.includes('@example')) {
        checkEmailIfExample = ''
    }

    const OnNewConvChannelSelected = props.OnNewConvChannelSelected
    const onNewConvName = props.onNewConvName
    const OnNewConvClicked = props.OnNewConvClicked

    const onChannelSelect = useCallback((channelId, msgType) => {
        OnNewConvChannelSelected(msgType)
        onNewConvName(channelId)
        setTimeout(() => OnNewConvClicked(), 0)

    }, [OnNewConvClicked, onNewConvName, OnNewConvChannelSelected])

    return <article className={`${styles['card-container']} ${props.nowSelectedContact?._id === _id && styles['card-container--selected']}`} onClick={props.onContactSelect}>
        <section className={styles['doc-info']}>
            <div>
                <p className={styles['fullname']}>{fullName}</p>
                <p className={styles['mainPhone']}>{mainPhone ? mainPhone.replace(/^\+972/, '0') : t('Empty phone')}</p>
                <p className={styles['email']}>{checkEmailIfExample ? checkEmailIfExample : t('Empty email')}</p>
            </div>
            <div className={styles['contact-card-actions']}>
                {appAccess !== 'DIALER' && checkEmailIfExample && <i onClick={() => onChannelSelect(checkEmailIfExample, 'mail')} className={`fas fa-envelope ${styles['action--email']}`} />}
                {mainPhone && <i onClick={props.CallBtClicked} className={`fas fa-phone-square ${styles['action--call']}`} />}
                {appAccess !== 'DIALER' && mainPhone && <i onClick={() => onChannelSelect(mainPhone, 'sms')} className={`fas fa-sms ${styles['action--sms']}`} />}
                {appAccess !== 'DIALER' && mainPhone && <i onClick={() => onChannelSelect(mainPhone, 'whatsapp')} className={`fab fa-whatsapp-square ${styles['action--whatsapp']}`} />}
                {/* {mainPhone && <i className={`fas fa-phone-square ${styles['action--call']} margin-right--5px`} />} */}
                {/* {mainPhone && <i className={`fas fa-sms ${styles['action--sms']}`} />} */}
                {/* {mainPhone && <i className={`fab fa-whatsapp-square ${styles['action--whatsapp']}`} />} */}
            </div>
        </section>
        <section className={styles['side-icon']}>
            <img src={contactIcon} onClick={(e) => { //e.stopPropagation();
             props.onContactListBtnClicked('edit', 'CONTACT') }} className={styles['icon-img']} alt='Contact icon' />
        </section>
    </article>
}

export default Contact